module.exports = __webpack_public_path__ + "4a9d2b11a2a7e4e5accaaa9ed963f1fb.svg";